export default {
  columns: [
    {
      title: 'Unus non sufficit orbis',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur hendrerit elit nunc, at porta ex accumsan id. Fusce quis lobortis sem, non ornare tellus.',
      images: [
        {
          url: 'https://via.placeholder.com/80',
          alttext: 'Logo 1',
          anchor: {
            href: 'https://www.google.it'
          }
        },
        {
          url: 'https://via.placeholder.com/80',
          alttext: 'Logo 2',
          anchor: {
            href: 'https://www.google.it'
          }
        }
      ]
    },
    {
      title: 'Privacy e info',
      links: [
        {
          text: 'Info su mambrino-fe',
          classes: 'link-class',
          anchor: {
            href: 'https://www.google.it'
          }
        },
        {
          text: 'Privacy policy',
          classes: 'link-class',
          anchor: {
            href: 'https://www.google.it'
          }
        },
        {
          text: 'Cooklie policy',
          anchor: {
            href: 'https://www.google.it'
          }
        },
        {
          text: 'Termini e condizioni',
          anchor: {
            href: 'https://www.google.it'
          }
        }
      ]
    },
    {
      classes: 'n7-footer__muruca-promo',
      text: "This project is powered by Muruca, a platform designed and developed by Net7, Pisa, Italy.<br><a href='http://www.muruca.org/' target='_blank'>www.muruca.org</a>, <a href='http://www.netseven.it' target='_blank'>www.netseven.it</a>",
      images: [
        {
          url: '/assets/logo-muruca-footer.png',
          alttext: 'Muruca digital library platform',
          anchor: {
            href: 'https://www.muruca.org'
          }
        },
        {
          url: '/assets/logo-net7.png',
          alttext: 'Net7 Pisa',
          anchor: {
            href: 'https://www.netseven.it'
          }
        }
      ]
    }
  ]
};
